import { TOptions } from 'i18next';
import lget from 'lodash/get';

import { useMemo } from 'react';

import { LocalizationKey, useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractSchemaQuery } from './queries';

interface UseTranslatedFormLabelArgs {
  options?: TOptions;
  path: string;
}

interface UseUISchemaReturnType {
  widget: string | undefined;
  isOptional: boolean;
}

interface UseUISchemaArgs {
  schemaId: string;
  path: string;
}

export function useTranslatedFormLabel({ path, options }: UseTranslatedFormLabelArgs) {
  const { t } = useTranslation();

  const normalizedPath = path.replace('carrier_configuration_data.', '').replace(/\.\d+$/, '');
  const translateKey = `carrierContracts.details.field.${normalizedPath}`;
  const translated = t(translateKey as LocalizationKey, options);

  return translated !== translateKey ? translated : normalizedPath;
}

export function useUISchema({ path, schemaId }: UseUISchemaArgs): UseUISchemaReturnType {
  const { data } = useCarrierContractSchemaQuery(schemaId);

  const entry = useMemo(() => {
    return lget(data?.ui_schema, path.replace('carrier_configuration_data.', ''));
  }, [data, path]);

  const isOptional = useMemo<boolean>(() => {
    return entry?.optional === true;
  }, [entry]);

  const widget = useMemo<string | undefined>(() => {
    return entry?.widget;
  }, [entry]);

  return {
    isOptional,
    widget,
  };
}
